import React from 'react';

import Spinner from '../spinner';
import VIDABOO_CONSTANTS from '../../../../config/consts';

const MultiStateSpinner = ({
  spinnerColor = VIDABOO_CONSTANTS.SPINNER_COLOR.BLUE,
  spinnerSize = VIDABOO_CONSTANTS.SPINNER_SIZE.LARGE,
}) => {
  return (
    <div
      className={`${
        spinnerSize === VIDABOO_CONSTANTS.SPINNER_SIZE.SMALL
          ? 'et-n-smallest-spinner'
          : spinnerSize === VIDABOO_CONSTANTS.SPINNER_SIZE.MEDIUM
            ? 'et-n-smaller-spinner'
            : ''
      } ${
        spinnerColor === VIDABOO_CONSTANTS.SPINNER_COLOR.WHITE
          ? 'et-n-white-bg-spinner'
          : ''
      }`}>
      <Spinner />
    </div>
  );
};

export default MultiStateSpinner;
